import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = ["fill"]
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<path d=\"m119.256 222.607h50.881v50.885h-50.881z\"></path><path d=\"m341.863 222.607h50.881v50.885h-50.881z\"></path><path d=\"m267.662 222.607h50.881v50.885h-50.881z\"></path><path d=\"m119.256 302.11h50.881v50.885h-50.881z\"></path><path d=\"m267.662 302.11h50.881v50.885h-50.881z\"></path><path d=\"m193.46 302.11h50.881v50.885h-50.881z\"></path><path d=\"m341.863 381.612h50.881v50.885h-50.881z\"></path><path d=\"m267.662 381.612h50.881v50.885h-50.881z\"></path><path d=\"m193.46 381.612h50.881v50.885h-50.881z\"></path><path d=\"m439.277 55.046h-41.376v39.67c0 14.802-12.195 26.84-27.183 26.84h-54.025c-14.988 0-27.182-12.038-27.182-26.84v-39.67h-67.094v39.297c0 15.008-12.329 27.213-27.484 27.213h-53.424c-15.155 0-27.484-12.205-27.484-27.213v-39.297h-41.376c-26.906 0-48.796 21.692-48.796 48.354v360.246c0 26.661 21.89 48.354 48.796 48.354h366.628c26.947 0 48.87-21.692 48.87-48.354v-360.246c0-26.661-21.923-48.354-48.87-48.354zm13.89 407.661c0 8.56-5.751 14.309-14.311 14.309h-365.712c-8.56 0-14.311-5.749-14.311-14.309v-284.618h394.334z\"></path><path d=\"m141.525 102.507h53.392c4.521 0 8.199-3.653 8.199-8.144v-73.87c0-11.3-9.27-20.493-20.666-20.493h-28.459c-11.395 0-20.668 9.192-20.668 20.493v73.87c.001 4.491 3.679 8.144 8.202 8.144z\"></path><path d=\"m316.693 102.507h54.025c4.348 0 7.884-3.513 7.884-7.826v-74.503c0-11.125-9.128-20.178-20.351-20.178h-29.091c-11.221 0-20.349 9.053-20.349 20.178v74.503c-.001 4.313 3.536 7.826 7.882 7.826z\"></path>", 12)
const _hoisted_14 = [
  _hoisted_2
]
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_16 = {
  key: 0,
  class: "fs14 fw600"
}
const _hoisted_17 = {
  key: 1,
  class: "posAb",
  style: {"bottom":"2px","right":"5px"}
}
const _hoisted_18 = {
  class: "dropdown-toggle fw600 centered fs12",
  style: {"width":"25px","background-color":"transparent","border":"none","appearance":"none","padding":"0","outline":"none"}
}
const _hoisted_19 = ["src"]
const _hoisted_20 = ["src"]
const _hoisted_21 = /*#__PURE__*/_createElementVNode("p", {
  role: "button",
  class: "fl mt5 mr20 mr4",
  style: {}
}, "複製", -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_23 = ["src"]
const _hoisted_24 = /*#__PURE__*/_createElementVNode("p", {
  role: "button",
  class: "fl mt5 mr5 mr4",
  style: {}
}, "デフォルトに変更", -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_26 = ["src"]
const _hoisted_27 = /*#__PURE__*/_createElementVNode("p", {
  role: "button",
  class: "fl mt5 mr20 alertRed",
  style: {}
}, "削除", -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_29 = ["src"]
const _hoisted_30 = /*#__PURE__*/_createElementVNode("p", {
  role: "button",
  class: "fl mt5 mr4",
  style: {}
}, "編集", -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_32 = {
  key: 3,
  class: "posAb",
  style: {"bottom":"6px","right":"5px"}
}
const _hoisted_33 = ["src"]
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_35 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_UserIcon = _resolveComponent("UserIcon")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_ctx.astag || _ctx.astagColor)
    ? (_openBlock(), _createElementBlock("section", {
        key: 0,
        class: _normalizeClass(`fl rad12 pointer ${_ctx.classes || `with_white_bg`}`),
        style: _normalizeStyle({
            width: `${_ctx.width}px`,
            height: `${_ctx.totalHeight}px`,
            border: _ctx.hideBorder ? `` : `solid 2px rgba(0, 0, 0, 0.097)`,
        })
      }, [
        _createElementVNode("div", {
          class: "upperContent posRe pad5",
          style: _normalizeStyle({
                height: `${_ctx.totalHeight}px`,
            })
        }, [
          _createElementVNode("div", {
            style: {"line-height":"13px"},
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.clickAstag && _ctx.clickAstag(...args)))
          }, [
            _createElementVNode("div", {
              class: "calendarIcon mc",
              style: _normalizeStyle({
                        width: `${_ctx.iconWidth}px`,
                        height: `${_ctx.iconWidth}px`,
                    })
            }, [
              (_openBlock(), _createElementBlock("svg", {
                viewBox: "0 0 900 900",
                style: _normalizeStyle({
                            width: `100%`,
                            height: `100%`,
                            ...(_ctx.iconStyles || {}),
                        }),
                xmlns: "http://www.w3.org/2000/svg",
                preserveAspectRatio: "xMinYMin slice"
              }, [
                _createElementVNode("g", {
                  fill: `#${_ctx.astagColor || _ctx.astag.color}`
                }, _hoisted_14, 8, _hoisted_1)
              ], 4))
            ], 4),
            _hoisted_15
          ]),
          (!_ctx.hideName)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                style: {"line-height":"16px","height":"50px","padding":"5px 2px"},
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.clickAstag && _ctx.clickAstag(...args)))
              }, [
                (_ctx.Util.isPresent(_ctx.astag.name))
                  ? (_openBlock(), _createElementBlock("p", _hoisted_16, _toDisplayString(_ctx.truncate(_ctx.astag.name, 20)), 1))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (_ctx.canDelete)
            ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                _createVNode(_component_Dropdown, {
                  ref: "dropdown",
                  id: "roomEditMenu",
                  style: {}
                }, {
                  dropdown: _withCtx(() => [
                    _createElementVNode("li", {
                      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.clickCopy && _ctx.clickCopy(...args))),
                      class: "fs12 pointer fw600 pad5",
                      style: {"line-height":"40px","width":"160px"}
                    }, [
                      _createElementVNode("img", {
                        src: _ctx.$getAssetImageUrl(`/assets/icons/copy_icon.png`),
                        width: "17",
                        height: "17",
                        class: "ml4 fl mt4 mr5",
                        style: {}
                      }, null, 8, _hoisted_20),
                      _hoisted_21,
                      _hoisted_22
                    ]),
                    (_ctx.astag.type != 2)
                      ? (_openBlock(), _createElementBlock("li", {
                          key: 0,
                          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.changeDefault && _ctx.changeDefault(...args))),
                          class: "fs12 pointer fw600 pad5",
                          style: {"line-height":"40px","width":"160px"}
                        }, [
                          _createElementVNode("img", {
                            src: _ctx.$getAssetImageUrl(`/assets/icons/editPen.png`),
                            width: "17",
                            height: "17",
                            class: "ml5 fl mt4 mr5",
                            style: {}
                          }, null, 8, _hoisted_23),
                          _hoisted_24,
                          _hoisted_25
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("li", {
                      onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.deleteAstag && _ctx.deleteAstag(...args))),
                      class: "fs12 pointer fw600 pad5",
                      style: {"line-height":"40px","width":"160px"}
                    }, [
                      _createElementVNode("img", {
                        src: _ctx.$getAssetImageUrl(`/assets/icons/status_ng.png`),
                        width: "17",
                        height: "17",
                        class: "ml7 fl mt6 mr5",
                        style: {}
                      }, null, 8, _hoisted_26),
                      _hoisted_27,
                      _hoisted_28
                    ])
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("button", _hoisted_18, [
                      _createElementVNode("img", {
                        src: _ctx.$getAssetImageUrl(`/assets/icons/line3.png`),
                        width: "20",
                        height: "20",
                        class: "fr pointer"
                      }, null, 8, _hoisted_19)
                    ])
                  ]),
                  _: 1
                }, 512)
              ]))
            : (_ctx.canEdit)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 2,
                  class: "fr",
                  onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.clickEdit && _ctx.clickEdit(...args)))
                }, [
                  _createElementVNode("img", {
                    src: _ctx.$getAssetImageUrl(`/assets/icons/editPen.png`),
                    width: "15",
                    height: "15",
                    class: "ml5 fl mt5 mr2",
                    style: {}
                  }, null, 8, _hoisted_29),
                  _hoisted_30,
                  _hoisted_31
                ]))
              : _createCommentVNode("", true),
          (_ctx.showSharedInfo && _ctx.astag.is_shared && _ctx.astag.owner)
            ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_32, [
                _createVNode(_component_UserIcon, {
                  member: _ctx.astag.owner,
                  width: 22,
                  canEdit: false,
                  updateSelf: false,
                  showTooltip: false,
                  class: "fr"
                }, null, 8, ["member"]),
                _createElementVNode("img", {
                  class: "fr mr2 mt2",
                  width: "18",
                  height: "18",
                  src: _ctx.$getAssetImageUrl(`/assets/icons/refresh.png`)
                }, null, 8, _hoisted_33),
                _hoisted_34
              ])), [
                [
                  _directive_tooltip,
                  `${_ctx.astag.owner.name}さんから\n共有を受けています`,
                  void 0,
                  { click: true }
                ]
              ])
            : _createCommentVNode("", true),
          _hoisted_35
        ], 4)
      ], 6))
    : _createCommentVNode("", true)
}